import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InfoService } from '../info.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { ThemeService } from '../theme.service';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
  providers: [ AuthenticationService ]
})
export class AccountSettingsComponent extends BaseComponent implements OnInit {

  email: string;
  username: string;
  profileImage: string;
  provider: string;

  screenToShow: string = "settings";

  @Output() onClose = new EventEmitter();
  @Output() onDeleteAccount = new EventEmitter();

  constructor(
    private infoService: InfoService,
    private themeService: ThemeService,
    private authService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {
    this.getInfo();
  }

  close() {
    this.onClose.emit();
  }

  getInfo() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if(sessionToken) {
      this.infoService.getUserDataBySessionToken(sessionToken, Global.getCountry()).subscribe(res => {
        if(res && res["status"] == "success") {
          this.email = res["mail"];
          this.username = res["username"];
          this.profileImage = res["profileImage"];
          this.provider = res["provider"];
        }
      }, err => {
        console.log(err);
      });
    }
    
  }

  getProfilePic(): string {
    return this.profileImage && this.profileImage != "placeholder" ? this.profileImage : "./assets/images/profile_placeholder.png";
  }

  getProviderImg(): string {
    if(this.provider == "facebook") {
      return "./assets/images/facebook.png";
    }
    if(this.provider == "apple") {
      return this.themeService.isDarkTheme() ? "./assets/images/apple_white.png" : "./assets/images/apple_black.png";
    }
    return "./assets/images/cc_logo.png";
  }

  getProviderName(): string {
    if(this.provider == "facebook") {
      return this.getString("facebook");
    }
    if(this.provider == "apple") {
      return this.getString("apple");
    }
    return this.getString("cheapcharts");
  }

  changeEmail() {
    this.screenToShow = "changeEmail";
  }

  changeUsername() {
    this.screenToShow = "changeUsername";
  }

  changePassword() {
    this.screenToShow = "changePassword";
  }

  deleteAccount() {
    this.onDeleteAccount.emit();
  }

  changeToApple() {
    this.screenToShow = "changeToApple";
  }

}